import Controller from '@ember/controller';
import { action } from '@ember/object';
import RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';

export default class Authenticated2faSetupIndex extends Controller {
  @service router!: RouterService;

  _canContinue = false;

  @action
  next() {
    return this.router.transitionTo('authenticated.2fa_setup.new_totp');
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'authenticated/2fa-setup/index': Authenticated2faSetupIndex;
  }
}
